import {
    FINANCE_TABLE_SET_YEAR_BOUNDS,
    FINANCE_TABLE_CHANGE_YEAR_BOUNDS,
    FINANCE_TABLE_SET_YEARS,
    FINANCE_TABLE_CHANGE_COMPARE_YEAR,
    FINANCE_TABLE_CHANGE_SAMPLE_YEAR,
    FINANCE_TABLE_REMOVE_OPEN_ROWS,
    FINANCE_TABLE_ADD_OPEN_ROW,
    FINANCE_TABLE_SET_OPEN_ROWS,
} from './constants'

/**
 * Sets lower and upperbound used in visible years slice to state.
 * Data is sliced using lower and upper bound to show columns according to data,
 * viewport and table shift (user can shift visible years left or right in table)
 * @param {string} id Table id, required for reducer
 * @param {number} lowerBound Lower bound used for years slice
 * @param {number} upperBound Upper bound used for years slice
 */
export function setYearBounds(id, tableType, lowerBound, upperBound) {
    return {
        type: FINANCE_TABLE_SET_YEAR_BOUNDS,
        data: {
            id,
            tableType,
            lowerBound,
            upperBound,
        },
    }
}

/**
 * Shifts visible years slice lower and upper bound left or right
 * @param {string} id Table id, required for reducer
 * @param {boolean} shiftLeft Direction of the shift (true - left, false - right)
 * @param {number} dataLength Length of table data
 */
export function changeYearBounds(id, tableType, shiftLeft = false, dataLength) {
    return {
        type: FINANCE_TABLE_CHANGE_YEAR_BOUNDS,
        data: {
            id,
            tableType,
            shiftLeft,
            dataLength,
        },
    }
}

/**
 * Sets compare year and sample year to state
 * @param {string} id Table id, required for reducer
 * @param {number} compareYear New selected compare year
 * @param {number} sampleYear New selected sample year
 */
export function setYears(id, tableType, compareYear, sampleYear) {
    return {
        type: FINANCE_TABLE_SET_YEARS,
        data: {
            id,
            tableType,
            compareYear,
            sampleYear,
        },
    }
}

/**
 * Changes compare year in state
 * @param {string} id Table id, required for reducer
 * @param {number} newYear New compare year value
 */
export function changeCompareYear(id, tableType, newYear) {
    return {
        type: FINANCE_TABLE_CHANGE_COMPARE_YEAR,
        data: {
            id,
            tableType,
            newYear,
        },
    }
}

/**
 * Changes sample year in state
 * @param {string} id Table id, required for reducer
 * @param {number} newYear New sample year value
 */
export function changeSampleYear(id, tableType, newYear) {
    return {
        type: FINANCE_TABLE_CHANGE_SAMPLE_YEAR,
        data: {
            id,
            tableType,
            newYear,
        },
    }
}

export function removeOpenRows(id, tableType, rowIds, openRows) {
    return {
        type: FINANCE_TABLE_REMOVE_OPEN_ROWS,
        data: {
            id,
            tableType,
            rowIds,
            openRows,
        },
    }
}

export function addOpenRow(id, tableType, rowId, openRows) {
    return {
        type: FINANCE_TABLE_ADD_OPEN_ROW,
        data: {
            id,
            tableType,
            rowId,
            openRows,
        },
    }
}

export function setOpenRows(id, tableType, newOpenRows) {
    return {
        type: FINANCE_TABLE_SET_OPEN_ROWS,
        data: {
            id,
            tableType,
            newOpenRows,
        },
    }
}
